import { BreakPointCondition, UI, useBreakpointIf, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Button } from 'native-base';
import { useCallback, useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { FilterModal } from '../../../../../../components/FilterModal';
import { useFilterTransformer } from '../../../../../../hooks/useFilterTransformer';
import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { assetsFiltersAtom } from '../../../../../../store/product/filters';
import { useGlobalAssetContext } from '../../contexts';

export const AssetFilters = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(assetsFiltersAtom);

  const { availableFilters, loadingCategories, hasSomeLoading, selectedTab, setFiltersToApply } =
    useGlobalAssetContext();

  const { transformFilters } = useFilterTransformer(availableFilters);

  useEffect(() => {
    setFiltersToApply(
      transformFilters(appliedFilters, {
        transformDateFilter: false,
        transformRangeFieldNames: true,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  if (!selectedTab.hasFilters) {
    return <></>;
  }

  return (
    <Button
      isLoading={loadingCategories}
      isLoadingText="Filtrar"
      spinnerPlacement="end"
      _text={{ textTransform: 'none' }}
      disabled={hasSomeLoading}
      onPress={() => navigate('BatchTicketAssetFiltersModal')}
      paddingX={Spacing['inline.xxxs']}
      variant="secondary"
      {...(!appliedFilters.length && { rightIcon: <UI.Icon name="Funnel" size="xxxs" /> })}>
      <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
        <UI.Text variant="semibold" fontSize={Typography['fontsize.md']}>
          Filtrar
        </UI.Text>
        {!!appliedFilters.length && (
          <Box
            rounded="full"
            w="20px"
            h="20px"
            alignItems="center"
            justifyContent="center"
            bg={'brand.tertiary.light'}>
            <UI.Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
              {appliedFilters.length}
            </UI.Text>
          </Box>
        )}
      </HStack>
    </Button>
  );
};

export const AssetFiltersDisabled = () => {
  return (
    <Button
      _text={{ textTransform: 'none' }}
      disabled
      isDisabled
      opacity={1}
      paddingX={Spacing['inline.xxxs']}
      variant="secondary"
      rightIcon={<UI.Icon name="Funnel" size="xxxs" />}>
      <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
        <UI.Text variant="semibold" fontSize={Typography['fontsize.md']}>
          Filtrar
        </UI.Text>
      </HStack>
    </Button>
  );
};

export const BatchTicketAssetFiltersModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={assetsFiltersAtom}
    />
  );
};
